import { useNavigate, useLocation } from 'react-router-dom'
import { LogOut, User, Menu, MessageSquare, Brain } from 'lucide-react'
import { useAuthStore } from '@/store/authStore'
import { useUIStore } from '@/store/uiStore'

export default function Header() {
  const navigate = useNavigate()
  const location = useLocation()
  const { user, logout } = useAuthStore()
  const { toggleSidebar, toggleMobileSessions } = useUIStore()
  const isChat = location.pathname === '/chat'

  const handleLogout = () => {
    logout()
    navigate('/login')
  }

  return (
    <header className="h-14 bg-surface/80 backdrop-blur border-b border-surface-border px-3 sm:px-4 flex items-center justify-between">
      {/* Left: Hamburger + Title */}
      <div className="flex items-center gap-2 sm:gap-3">
        {/* Hamburger menu - mobile only */}
        <button
          onClick={toggleSidebar}
          className="p-2 rounded-xl hover:bg-surface-hover transition-colors md:hidden"
        >
          <Menu className="w-5 h-5 text-text-muted" />
        </button>

        {/* Logo + Title on mobile */}
        <div className="flex items-center gap-2 md:hidden">
          <div className="w-8 h-8 rounded-lg bg-gradient-to-br from-accent/20 to-accent/5 flex items-center justify-center">
            <Brain className="w-4 h-4 text-accent" />
          </div>
          <span className="text-text font-semibold">Neuro-HA</span>
        </div>
      </div>

      {/* Right: Actions */}
      <div className="flex items-center gap-2 sm:gap-3">
        {/* Sessions button - mobile only, only on chat page */}
        {isChat && (
          <button
            onClick={toggleMobileSessions}
            className="p-2 rounded-xl hover:bg-surface-hover transition-colors md:hidden"
            title="Chat history"
          >
            <MessageSquare className="w-5 h-5 text-text-muted" />
          </button>
        )}

        {/* User info */}
        <div className="hidden sm:flex items-center gap-2 text-sm px-3 py-1.5 rounded-xl bg-surface-hover/50">
          <div className="w-6 h-6 rounded-full bg-accent/20 flex items-center justify-center">
            <User className="w-3 h-3 text-accent" />
          </div>
          <span className="text-text">{user?.username}</span>
          <span className="text-text-muted capitalize text-xs">({user?.role})</span>
        </div>

        {/* Logout */}
        <button
          onClick={handleLogout}
          className="p-2 rounded-xl hover:bg-red-500/10 hover:text-red-400 text-text-muted transition-colors"
          title="Logout"
        >
          <LogOut className="w-4 h-4" />
        </button>
      </div>
    </header>
  )
}
